/**
 * 브라우저의 Firebase 클라이언트 SDK 연결 — 앱 초기화가 사는 유일한 곳이다.
 *
 * ## ⚠️ 값이 아니라 함수로 내준다
 * 모듈 최상단에서 `initializeApp`을 돌리면 이 파일을 **스치기만 한** 모듈(서버 route가
 * import한 공용 상수 파일까지)이 클라이언트 SDK를 초기화한다. 함수로 내주면 부르는 쪽이
 * 필요할 때만 켜진다 — 그러니 여기서 모듈 최상단 초기화를 되살리면 안 된다.
 *
 * ## ⚠️ 서버는 이 파일을 쓰지 않는다
 * 서버 몫은 `lib/firebase-admin`(admin SDK)이다. route handler에서 클라이언트 SDK를
 * import하면 서버가 브라우저용 권한 규칙 아래에서 Firestore를 친다.
 */

import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';
import { getApp, getApps, initializeApp, type FirebaseApp } from 'firebase/app';

import { CONFIG } from 'src/global-config';

export function getFirebaseApp(): FirebaseApp {
  return getApps().length ? getApp() : initializeApp(CONFIG.firebase);
}

export function getFirebaseAuth(): Auth {
  return getAuth(getFirebaseApp());
}

export function getFirebaseFirestore(): Firestore {
  return getFirestore(getFirebaseApp());
}
